// src/components/common/jackpotDisplay.ts

import { createElement } from "../../utils/domHelpers";
import { animateValue } from "../../utils/formatters";
import { Jackpot } from "../../types/api";

/**
 * Renders the jackpot display element.
 *
 * @param parentDiv - The HTMLElement to append the jackpot display to.
 * @param jackpotData - The jackpot data containing the amount and optionally title/description.
 * @param countUp - Whether to animate the jackpot amount with a count-up effect.
 */
export function renderJackpot(
	parentDiv: HTMLElement,
	jackpotData: Jackpot | null,
	countUp: boolean = true
): void {
	if (!jackpotData) {
		console.warn("Jackpot data is null, cannot render display.");
		parentDiv.innerHTML = ""; // Clear parent if no data
		return;
	}

	parentDiv.innerHTML = ""; // Clear previous content

	// Pre-text (e.g., "NATIONAL JACKPOT")
	const preText = createElement(
		"h6",
		{
			className: "text-light tracking-widest text-center jackpot-pre-text", // Classes from original
			innerHTML: "CURRENT<br/>JACKPOT", // Text from original
		},
		parentDiv
	);

	// Jackpot Amount
	const amountId = `jackpot-number-${
		parentDiv.id || Math.random().toString(36).substring(7)
	}`; // Create unique ID
	const amountH1 = createElement(
		"h1",
		{
			className: "text-black text-center jackpotText ps-2 goldGradientText", // Classes from original
			// Format initial amount (without cents)
			innerHTML: `$<span id="${amountId}">${(
				jackpotData.jackpot_amount / 100
			).toFixed(0)}</span>`,
		},
		parentDiv
	);

	// Animate if requested
	if (countUp) {
		// Use a short delay to ensure the element is in the DOM before animating
		setTimeout(() => {
			animateValue(amountId, jackpotData.jackpot_amount / 100); // Animate to the value in dollars
		}, 50); // 50ms delay, adjust if needed
	}
}
